import { render } from "./NykCard.vue?vue&type=template&id=aa62d9aa"
import script from "./NykCard.vue?vue&type=script&lang=js"
export * from "./NykCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__